import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { MatInput } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { NodeActionsService } from '../../services/node-actions.service';
import { WorkflowStepService } from '../../workflow-step.service';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { take } from 'rxjs/operators';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { CurrentAutomationService } from '@galaxy/automata/shared';

@Component({
  selector: 'automata-group-modal',
  templateUrl: './group-modal.component.html',
  styleUrls: ['./group-modal.component.scss'],
  imports: [
    MatDialogTitle,
    TranslateModule,
    MatDialogContent,
    GalaxyFormFieldModule,
    GalaxyLoadingSpinnerModule,
    MatInput,
    ReactiveFormsModule,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    FormsModule,
    GalaxyButtonLoadingIndicatorModule,
  ],
})
export class GroupModalComponent {
  public loading = false;

  public groupId: string = this.data?.groupId || '';
  public groupName: string = this.data?.groupName || '';
  public maxNameLength = 500;
  public groupNotes: string = this.data?.groupNotes || '';
  public maxNotesLength = 5000;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: Partial<{ groupName: string; groupNotes: string; groupId: string; isEdit: boolean }>,
    public dialogRef: MatDialogRef<GroupModalComponent>,
    private currentAutomationService: CurrentAutomationService,
    private workflowStepService: WorkflowStepService,
    private nodeActionsService: NodeActionsService,
    private snackbarService: SnackbarService,
    private translateService: TranslateService,
  ) {}

  public cancel(): void {
    this.dialogRef.close();
  }

  public save(): void {
    if (this.loading || this.groupNotes?.length > this.maxNotesLength || !this.groupName) return;

    this.loading = true;

    let res: Observable<boolean>;
    if (this.groupId) {
      res = this.workflowStepService.updateGroupDetails(this.currentAutomationService.automation()!, {
        id: this.groupId,
        name: this.groupName,
        notes: this.groupNotes,
      });
    } else {
      res = this.workflowStepService.addGroupToAutomation(
        this.currentAutomationService.automation()!,
        this.groupName,
        this.nodeActionsService.stepsInGroup(),
      );
    }

    res
      .pipe(take(1))
      .subscribe({
        next: (succeeded) => {
          if (succeeded) {
            this.dialogRef.close();
            this.nodeActionsService.endGrouping();
          }
        },
        error: this.displayError.bind(this),
      })
      .add(() => (this.loading = false));
  }

  private displayError(): void {
    this.snackbarService.openErrorSnack(this.translateService.instant('AUTOMATIONS.GROUPING.SUBMIT_ERROR'));
  }
}
